var map = {
	"./Combined Shape.svg": [
		5108,
		5108
	],
	"./add.svg": [
		8371,
		8371
	],
	"./addPerson.svg": [
		6716,
		6716
	],
	"./alert.svg": [
		192,
		192
	],
	"./archive.svg": [
		7752,
		5371
	],
	"./arrow-right.svg": [
		6876,
		6876
	],
	"./bank.svg": [
		6500,
		6500
	],
	"./bankid.svg": [
		4307,
		4307
	],
	"./barista.svg": [
		8312,
		8312
	],
	"./bartender.svg": [
		87,
		87
	],
	"./bell.svg": [
		333,
		333
	],
	"./calendar.svg": [
		3300,
		3300
	],
	"./camera.svg": [
		6827,
		6827
	],
	"./card.svg": [
		5371,
		7752
	],
	"./cashier.svg": [
		4433,
		4433
	],
	"./chat.svg": [
		1244,
		1244
	],
	"./checkmark.svg": [
		1033,
		1033
	],
	"./chef.svg": [
		2586,
		2586
	],
	"./chevron-down.svg": [
		2764,
		2764
	],
	"./chevron-left.svg": [
		5211,
		5211
	],
	"./chevron-right.svg": [
		734,
		734
	],
	"./chevron-up.svg": [
		135,
		135
	],
	"./clock.svg": [
		5980,
		5980
	],
	"./clone.svg": [
		2165,
		2165
	],
	"./company.svg": [
		3779,
		3779
	],
	"./cross.svg": [
		7102,
		7102
	],
	"./day.svg": [
		9920,
		9920
	],
	"./dishwasher.svg": [
		5702,
		5702
	],
	"./document.svg": [
		6077,
		6077
	],
	"./doorman.svg": [
		8670,
		8670
	],
	"./download.svg": [
		8782,
		8782
	],
	"./downward_arrow.svg": [
		1425,
		3806
	],
	"./duplicate.svg": [
		5697,
		5697
	],
	"./eye.svg": [
		7057,
		7057
	],
	"./favorites-active.svg": [
		4792,
		4792
	],
	"./favorites-inactive.svg": [
		6753,
		6753
	],
	"./filter.svg": [
		7148,
		7148
	],
	"./group.svg": [
		9535,
		9535
	],
	"./hamburger.svg": [
		3183,
		3183
	],
	"./home-cleaning.svg": [
		517,
		517
	],
	"./hotel-cleaning.svg": [
		7496,
		7496
	],
	"./idbadge.svg": [
		7466,
		7466
	],
	"./image.svg": [
		741,
		741
	],
	"./kitchen.svg": [
		3398,
		3398
	],
	"./letter.svg": [
		4186,
		4186
	],
	"./list.svg": [
		1530,
		1530
	],
	"./lock.svg": [
		1287,
		1287
	],
	"./logout.svg": [
		8908,
		8908
	],
	"./mail.svg": [
		4827,
		4827
	],
	"./message.svg": [
		3379,
		3379
	],
	"./minus.svg": [
		8026,
		8026
	],
	"./minus_old.svg": [
		1156,
		1156
	],
	"./overflow.svg": [
		4104,
		4104
	],
	"./paginationArrowLeft.svg": [
		2098,
		2098
	],
	"./paginationArrowRight.svg": [
		441,
		441
	],
	"./pen.svg": [
		3999,
		3999
	],
	"./person.svg": [
		3325,
		3325
	],
	"./phone.svg": [
		3998,
		3998
	],
	"./pin.svg": [
		6099,
		6099
	],
	"./play.svg": [
		4668,
		4668
	],
	"./plus.svg": [
		8546,
		8546
	],
	"./plus_old.svg": [
		5948,
		5948
	],
	"./preparation.svg": [
		2773,
		2773
	],
	"./question.svg": [
		1238,
		1238
	],
	"./receipt.svg": [
		7222,
		7222
	],
	"./receptionist.svg": [
		979,
		979
	],
	"./reload.svg": [
		4261,
		4261
	],
	"./search.svg": [
		7622,
		7622
	],
	"./security-guard.svg": [
		9616,
		9616
	],
	"./settings.svg": [
		7733,
		7733
	],
	"./share.svg": [
		8051,
		8051
	],
	"./star-filled.svg": [
		3859,
		3859
	],
	"./star.svg": [
		1817,
		4198
	],
	"./trashcan.svg": [
		3126,
		3126
	],
	"./upward_arrow.svg": [
		6697,
		6697
	],
	"./user-minus.svg": [
		6016,
		6016
	],
	"./video.svg": [
		371,
		371
	],
	"./wallet.svg": [
		4457,
		4457
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5744;
module.exports = webpackAsyncContext;